import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet>
      <lib-spinner></lib-spinner>
    </router-outlet>
  `,
  styles: [],
})
export class AppComponent {
  constructor() {}
}
